export const FILTER_TYPES = {
    CHECKBOX: 'checkbox',
    CHECKBOX_GROUP: 'checkbox_group',
    RADIO: 'radio',
    INPUT_RANGE: 'input_range',
    AUTO_COMPLETE: 'autocomplete',
    MULTI_PAIRS_SELECT: 'multi_pairs_select',
    PRO: 'pro',
    TOGGLE: 'toggle'
};

export const FILTERS_EXTRAS_PROPS = {
    [FILTER_TYPES.AUTO_COMPLETE]: {
        showClear: true,
        placeholder: 'search_perseus.filter.seller_location.placeholder'
    }
};

export const FILTERS_DISPLAY = {
    'delivery_time': FILTER_TYPES.AUTO_COMPLETE
};

export const MAX_GIG_PRICE_RANGE = 50000;
export const MIN_GIG_PRICE_RANGE = 0;
